(function () {
    'use strict';

    angular
        .module('skillsApp')
        .directive('elearningActivityEditor', elearningActivityEditor);

    function elearningActivityEditor() {
        return {
            templateUrl: '/app/directives/activities/elearning-activity-editor.tpl.html',
            scope: {
                item: '=',
                catalogItems: '=',
                editMode: '=',
            },
            controller: ElearningActivityEditorController,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function ElearningActivityEditorController() {
        var vm = this;
        
        vm.items = _.where(vm.catalogItems, { targetType: 1 });
        vm.selected = _.findWhere(vm.items, { targetId: vm.item.targetId });

        vm.change = change;
        
        function change() {
            vm.item.targetId = vm.selected.targetId;
        }
    }

})();